import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Typography,
  Tooltip,
} from "antd";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { ToTopOutlined, ExclamationCircleOutlined, EyeOutlined, EditOutlined, SearchOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import apiPath from "../../constants/apiPath";
// import EditIcon from "../../assets/images/edit-btn.svg"
// import ViewIcon from "../../assets/images/view-btn.svg"
const { Title } = Typography;
const Search = Input.Search;

function EmailTemplate() {
  const { request } = useRequest();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ 
    current: 1, 
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSizeOptions: ['10', '20', '50', '100'],
  });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [viewingEmail, setViewingEmail] = useState(null);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [selected, setSelected] = useState();
  const { confirm } = Modal;

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `/admin/email-template/status-change/${record}`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  
  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };
  
  const routeName = "email-template";

  const view = (id) => {
    request({
      url: `${apiPath.getEmailById}?email_id=${id}`,
      method: 'GET',
      onSuccess: (response) => {
        if (response.status) {
          setViewingEmail(response.data);
          setViewModalVisible(true);
        }
      },
      onError: () => {
        ShowToast('Failed to fetch email details', Severty.ERROR);
      }
    });
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (_, { title }) => (title ? title : "-"),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      render: (_, { subject }) => (subject ? subject : "-"),
    },
    {
      title: "Created",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div className="d-flex justify-content-start gap-2">
            <Button
              onClick={() => view(record.id)}
            >
              
              <EyeOutlined />
            </Button>
            <Button
              onClick={() => {
                setSelected(record);
                setVisible(true);
              }}
            >
              
              <EditOutlined />
            </Button>
          </div>
        );
      },
    },
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination(prev => ({ ...prev, current: 1 }));
  };
  
  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText]);

  const fetchData = (paginationInfo) => {
    const currentPage = paginationInfo?.current || 1;
    const pageSize = paginationInfo?.pageSize || 10;
    
    const params = new URLSearchParams({
      page: currentPage,
      page_size: pageSize,
    });

    // Add search parameter if search text exists
    if (debouncedSearchText) {
      params.append('search', debouncedSearchText);
    }

    request({
      url: `${apiPath.getAllEmails}?${params}`,
      method: "GET",
      onSuccess: (response) => {
        setLoading(false);
        if (response.status) {
          setList(response.data || []);
          setPagination((prev) => ({
            ...prev,
            current: response.pagination?.current_page || currentPage,
            pageSize: response.pagination?.page_size || pageSize,
            total: response.pagination?.total_count || 0,
          }));
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (paginationInfo, filters, sorter) => {
    fetchData(paginationInfo);
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col xs="24" md={24} lg={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Email Template Manager"
              extra={
                <>
                  <div className="w-100 d-flex align-items-baseline text-head_right_cont">
                    <div className="pageHeadingSearch d-flex gap-2">
                     
                  <Input
                    prefix={<SearchOutlined />} 
                    onChange={onSearch}
                        value={searchText}
                        onPressEnter={onSearch}
                        placeholder="Search by Title, Subject"
                        allowClear
                  />
                    </div>
                  </div>
                  {/* <Button onClick={() => setVisible(true)}>Add Psychologist</Button> */}
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={pagination}
                  onChange={handleChange}
                  className="ant-border-space"
                  rowKey="id"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddFrom
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      
      {/* View Email Modal */}
      <Modal
        visible={viewModalVisible}
        onCancel={() => setViewModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setViewModalVisible(false)}>
            Close
          </Button>
        ]}
        className="tab_modal"
        width={800}
      >
             <Title level={3}>Email Template Details</Title>
        {viewingEmail && (
          <div>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <strong>Title:</strong> {viewingEmail.title}
              </Col>
              <Col span={12}>
                <strong>Subject:</strong> {viewingEmail.subject}
              </Col>
              <Col span={24}>
                <strong>Template Content:</strong>
                <div 
                  style={{ 
                    border: '1px solid #d9d9d9', 
                    padding: '10px', 
                    marginTop: '8px',
                    maxHeight: '300px',
                    overflow: 'auto'
                  }}
                  dangerouslySetInnerHTML={{ __html: viewingEmail.template_content }}
                />
              </Col>
              <Col span={12}>
                <strong>Created At:</strong> {new Date(viewingEmail.created_at).toLocaleString()}
              </Col>
              <Col span={12}>
                <strong>Updated At:</strong> {new Date(viewingEmail.updated_at).toLocaleString()}
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    </>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  
  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ 
      title: data.title,
      subject: data.subject,
      description: data.template_content
    });
    setContent(data.template_content);
  }, [data]);
  
  const handleContentChange = (newContent) => {
    setContent(newContent);
    form.setFieldsValue({ description: newContent });
  };
  
  const onCreate = (values) => {
    const { description, title, subject } = values;
    const payload = {};
    setLoading(true);
    payload.description = description;
    payload.title = title;
    payload.subject = subject;
    request({
      url: apiPath.updateEmail,
      method: 'PUT',
      data: {
        email_id: data.id,
        title,
        subject,
        template_content: description,
      },
      onSuccess: (response) => {
        setLoading(false);
        if (response.status) {
          ShowToast(response.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(response.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast('Failed to update email template', Severty.ERROR);
        setLoading(false);
      },
    });
  };
  
  return (
    <Modal
      className="tab_modal"
      visible={show}
      title={false}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 class="modal_title_cls">{`${data ? "Edit" : "Create"}`}</h4>
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Please input the title!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Subject"
              name="subject"
              rules={[{ required: true, message: "Please input the subject!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                { required: true, message: "Please Enter the  description!" },
              ]}
            >
              <ReactQuill value={content} onChange={handleContentChange} />
              {/* <TextArea rows={4} /> */}
              {/* <Input type="textarea" /> */}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EmailTemplate;